import { render, staticRenderFns } from "./enlaces-de-interes.vue?vue&type=template&id=00743ed6&scoped=true"
var script = {}
import style0 from "./enlaces-de-interes.vue?vue&type=style&index=0&id=00743ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00743ed6",
  null
  
)

export default component.exports